import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import TextField from "@material-ui/core/TextField";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import get from "lodash/get";
import React, { Component } from "react";
import Select from "react-select";
import { instance } from "../../../Actions/AxiosInstance";
import "./index.css";
import { ErrorMessages } from "../../../Constants";

const menuActions = [
  {
    id: 1,
    name: "Edit",
  },
  {
    id: 2,
    name: "Delete",
  },
];

export default class DeviceGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.currentgroup && this.props.currentgroup.groupname,
      errorname: false,
      menuopen: false,
      open: false,
      devicegroupList: this.props.devicegroupList ? this.props.devicegroupList : [],
      menu: null,
      selecteddevicegroup: this.props.selecteddevicegroup && this.props.selecteddevicegroup ? this.props.selecteddevicegroup : [],
      currentgroup: this.props.currentgroup && this.props.currentgroup,
    };

    this.handleChange = this.handleChange.bind(this);
    this.selectMenu = this.selectMenu.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCloseDrawer = this.onCloseDrawer.bind(this);
  }

  handleChange(name, type, e) {
    const errorname = `error${name}`;
    if (type == "text") {
      if (!/[a-zA-Z]/.test(e.target.value)) {
        this.setState({
          [errorname]: true,
          [name]: e.target.value,
        });
      } else {
        this.setState({
          [errorname]: false,
          [name]: e.target.value,
        });
      }
    } else if (e && e.length > 0) {
      this.setState({
        [errorname]: false,
        [name]: e,
      });
    } else {
      this.setState({
        [errorname]: true,
        [name]: e,
      });
    }
  }

  onMenuClick(group) {
    this.setState({
      menuopen: true,
      selectedgroup: group,
      selecteddevicegroupid: group.devicegroupid,
    });
  }

  onClickAway() {
    this.setState({
      menuopen: false,
      selecteddevicegroupid: "",
    });
  }

  selectMenu(menuid, group) {
    this.setState(
      {
        menuopen: false,
        open: true,
        menu: menuid,
      },
      () => {
        if (menuid == 1) {
          if (group) {
            instance
              .get(`biometric/initdevicegroup/${this.state.selectedgroup.devicegroupid || group.devicegroupid}`)
              .then((result) => {
                const devicegroupList = result.data.result[0].newdevices;
                const selecteddevicegroup = result.data.result[0].addeddevices;
                this.setState({
                  currentgroup: result.data.result[0],
                  name: result.data.result[0].groupname,
                  devicegroupList,
                  selecteddevicegroup,
                  originaldevices: selecteddevicegroup,
                });
              })
              .catch((error) => {
                this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
              });
          } else {
            this.props.enqueueSnackbar("Group not found", { variant: "error" });
          }
        } else if (menuid == 2) {
          instance
            .delete(`biometric/deletedevicegroup/${this.state.selectedgroup.devicegroupid || group.devicegroupid}`)
            .then(() => {
              this.props.enqueueSnackbar("Deleted successfully", { variant: "success" });
              // this.props.getDeviceGroupList();
              // this.props.getInitDeviceList();
              this.props.closeDrawer();
            })
            .catch((error) => {
              this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
            });
        }
      },
    );
  }

  onSave() {
    let added = [];
    let removed = [];
    let addeddataa = [];
    if (this.state.currentgroup.devicegroupid) {
      added = this.state.selecteddevicegroup && this.state.selecteddevicegroup.filter(
        (device) => device.biometricdeviceid != this.state.originaldevices.map((olddevice) => olddevice.biometricdeviceid),
      );
      let isaddeddata = false;
      this.state.selecteddevicegroup.map(x => {
        const data = this.state.originaldevices.find(y => y.biometricdeviceid == x.biometricdeviceid);
        if (!data) {
          isaddeddata = true;
        }
      })
      if (added == []) {
        this.props.enqueueSnackbar("Please fill all fields", { variant: "error" });
        return;
      }

      addeddataa = isaddeddata ? added : [];

      let isremoveddata = false;
      this.state.originaldevices.map(x => {
        const data = this.state.selecteddevicegroup.find(y => y.biometricdeviceid == x.biometricdeviceid);
        if (!data) {
          isremoveddata = true;
        }
      })

      removed = isremoveddata ? this.state.originaldevices.filter(
        (device) => device.biometricdeviceid != this.state.selecteddevicegroup.map((olddevice) => olddevice.biometricdeviceid),
      ) : [];
      // added = this.state.selecteddevicegroup.filter(
      //   (device) => device.biometricdeviceid != this.state.originaldevices.map((olddevice) => olddevice.biometricdeviceid),
      // );
      // added = this.state.selecteddevicegroup;
      // if (added == []) {
      //   this.props.enqueueSnackbar("Please fill all fields", { variant: "error" });
      //   return;
      // }

      // removed = this.state.originaldevices.filter(
      //   (device) => this.state.selecteddevicegroup.map((olddevice) => device.biometricdeviceid !== olddevice.biometricdeviceid),
      // );
    }

    if (this.state.name == "" || this.state.selecteddevicegroup == null || this.state.selecteddevicegroup.length < 1) {
      this.props.enqueueSnackbar("Please fill all fields", { variant: "error" });
    } else {
      const data = {
        name: this.state.name,
        id: this.state.menu == 1 ? this.state.currentgroup.devicegroupid : null,
      };
      instance
        .post("biometric/checkuniquedevicegroupname", data)
        .then((result) => {
          if (result.data.result[0].isunique) {
            const postdata = {
              groupname: this.state.name,
              adddevicearray: this.state.currentgroup.devicegroupid ? addeddataa.length > 0 ? addeddataa : null : added.length > 0 ? added : this.state.selecteddevicegroup,
              // adddevicearray: addeddataa.length > 0 ? addeddataa : null,
              removedevicearray: removed.length > 0 ? removed : null,
              devicegroupid: this.state.menu == 1 ? this.state.currentgroup.devicegroupid : null,
            };
            instance
              .post("biometric/createdevicegroup", postdata)
              .then(() => {
                this.props.enqueueSnackbar("Saved successfully", { variant: "success" });
                this.props.closeDrawer();
              })
              .catch((error) => {
                this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
              });
          } else {
            this.props.enqueueSnackbar(ErrorMessages.E0110, { variant: "error" });
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
        });
    }
  }

  onCloseDrawer() {
    this.props.closeDrawer();
  }

  render() {
    return (
      <div>
        <div className="formwrapper" tabIndex="1">
          <span className="drawer-cancle-btn">
            <svg onClick={this.onCloseDrawer} width="24" height="24" viewBox="0 0 24 24">
              <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
            </svg>
          </span>
          <p className="title">Device Groups</p>
          <p className="subtitle">Add Group</p>
          <div className="margin-bottom-16">
            <p className="form-input-label">Group Name</p>
            <TextField
              id="outlined-dense"
              margin="dense"
              className="input"
              variant="outlined"
              placeholder="Enter Group Name"
              onChange={(e) => this.handleChange("name", "text", e)}
              value={this.state.name}
              maxLength="100"
            />
          </div>
          <div className="margin-bottom-16">
            <p className="form-input-label">Select Devices</p>
            <Select
              isMulti
              className="width77"
              onChange={(e) => this.handleChange("selecteddevicegroup", "select", e)}
              // options={this.state.devicegroupList}
              options={get(this.props, "currentgroup.newdevices", [])}
              getOptionLabel={(option) => option.devicename}
              getOptionValue={(option) => option.biometricdeviceid}
              value={this.state.selecteddevicegroup}
              placeholder=""
            />
          </div>
          <div style={{ borderBottom: "1px dashed #707070" }}>
            <Button className={this.state.menu == 1 ? "savebutton" : "addbutton"} onClick={this.onSave}>
              {this.state.menu == 1 ? " SAVE" : "ADD"}
            </Button>
          </div>

          <div style={{ marginBottom: 16 }}></div>
          <div>
            <ul className="list">
              <li className="columlist1">
                <div>
                  <span className="form-sub-header">Group Name</span>
                </div>
              </li>
              <li className="columlist2">
                <div>
                  <span className="form-sub-header">Devices in Group</span>
                </div>
              </li>
            </ul>
            {this.props.devicegroups
              && this.props.devicegroups.length > 0
              && this.props.devicegroups.map((group, i) => (
                <div className="margin-bottom-4">
                  <ul className="list">
                    <li className="columlist1">
                      <div className="floatleft">{group && group.groupname}</div>
                    </li>
                    <li className="columlist2">
                      <div className="floatleft margin-left-4">
                        {group && group.devicejson && group.devicejson.map((device) => <div>{device.devicename}</div>)}
                      </div>
                      <div className="floatright">
                        <IconButton
                          aria-label="More"
                          className="actionbutton"
                          buttonRef={(node1) => {
                            this[`anchorEl${i}`] = node1;
                          }}
                          onClick={() => this.onMenuClick(group)}
                        >
                          <MoreVertIcon />
                        </IconButton>

                        <Popper
                          open={this.state.menuopen && group.devicegroupid == this.state.selecteddevicegroupid}
                          // anchorEl={this.anchorEl}
                          anchorEl={this[`anchorEl${i}`]}
                          placement="right"
                          transition
                          disablePortal
                          style={{ zIndex: 1111, padding: "0px 10px" }}
                          className="position-abs"
                        >
                          {({ TransitionProps }) => (
                            <Grow {...TransitionProps}>
                              <Paper>
                                <ClickAwayListener onClickAway={this.onClickAway}>
                                  <MenuList>
                                    {menuActions.map((option) => (
                                      <MenuItem onClick={() => this.selectMenu(option.id, group)}>{option.name}</MenuItem>
                                    ))}
                                  </MenuList>
                                </ClickAwayListener>
                              </Paper>
                            </Grow>
                          )}
                        </Popper>
                      </div>
                    </li>
                  </ul>

                  <br />
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}
